import styled from 'styled-components';

const ShopCartContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: ${({ theme }) => theme.constants.lateralSpace};
  span {
    ${({ theme }) => theme.fontFamily.secondaryFont.smallRegular}
    line-height: 20px;
    color: ${({ theme }) => theme.colors.textSecondary};
  }
`;

export default ShopCartContainer;
